import { FC } from "react";
import { Position, Handle, NodeProps } from "@xyflow/react";
import { useErrorModal } from "@/components/forms/errorHandling/useErrorModal";
import styles from "@/components/company/companyHierarchyNode.module.css";

interface CompanyHierarchyNodeProps extends NodeProps {
  data: {
    label: string;
    subjectId: string;
    isHighlighted: boolean;
  };
  disableClickForHighlightedNode: boolean;
}

const CompanyHierarchyNode: FC<CompanyHierarchyNodeProps> = ({
  data,
  disableClickForHighlightedNode,
}) => {
  const isHighlighted = data.isHighlighted || false;
  const { handleError, errorModal } = useErrorModal();

  const handleNodeClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (isHighlighted && disableClickForHighlightedNode) {
      return;
    }

    if (data.subjectId) {
      const url = `/subjectOverview/${data.subjectId}`;
      window.open(url, "_blank");
    } else {
      handleError("error_occurred");
    }
  };

  const isClickDisabled = isHighlighted && disableClickForHighlightedNode;

  return (
    <>
      <div
        data-selected={isHighlighted}
        onClick={handleNodeClick}
        className={`
          ${styles.node} 
          ${isHighlighted ? styles.selectedNode : ""}
          ${isClickDisabled ? styles.disabledNode : ""}
        `}
      >
        <Handle
          type="target"
          position={Position.Top}
          className={styles.nodeHandle}
        />
        <div className={styles.nodeLabel}>{data.label}</div>
        <Handle
          type="source"
          position={Position.Bottom}
          className={styles.nodeHandle}
        />
      </div>
      {errorModal}
    </>
  );
};

export default CompanyHierarchyNode;
